import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

import { api } from "@/api"
import { BASE_URL, ENDPOINTS } from "@/constants"

interface ReprocessPaymentEventProps {
  paymentId: string
}

export const useReprocessPaymentEventMutation = (
  orderCode: string
) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({
      paymentId,
    }: ReprocessPaymentEventProps) => {
      const url = `${BASE_URL}/admin/payments/${paymentId}/status-event-reprocess`
      await api.post(url)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.ORDERS],
      })
      await queryClient.invalidateQueries({
        queryKey: [
          "orders",
          { code: orderCode, page: 1, pageSize: 10 },
        ],
      })
    },
  })
}
